import React from "react";
import { Controller } from "react-hook-form";
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Box } from "@mui/material";
import { canadaGibsonFont } from "../Config";

export default function RHFSelect({
    name,
    label,
    control,
    options = {},
    defaultValue = "",
    fullWidth = true,
    errors,
    ...muiProps
}) {
    let colourMap;

    const renderOptions = () => {
        if (Array.isArray(options)) {
            colourMap = Object.assign({}, ...options);
            return options.map((opt) => {
                if (typeof opt === "object" && opt !== null) {
                    const [label, hex] = Object.entries(opt)[0];

                    let topColor, bottomColor;
                    if (hex && typeof hex === "string" && hex.includes(",")) {
                        [topColor, bottomColor] = hex.split(",").map((c) => c.trim());
                    } else {
                        topColor = bottomColor = hex;
                    }

                    return (
                        <MenuItem key={label} value={label} sx={canadaGibsonFont}>
                            {topColor && bottomColor && (
                                <Box
                                    sx={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%",
                                        background: `linear-gradient(to bottom, ${topColor} 55%, ${bottomColor} 45%)`,
                                        mr: 1,
                                    }}
                                />
                            )}
                            {label}
                        </MenuItem>
                    );
                }

                return (
                    <MenuItem key={opt} value={opt} sx={canadaGibsonFont}>
                        {opt}
                    </MenuItem>
                );
            });
        }

        return Object.entries(options).map(([value]) => (
            <MenuItem key={value} value={value} sx={canadaGibsonFont}>
                {value}
            </MenuItem>
        ));
    };

    const fieldError = name.split(".").reduce((obj, key) => obj?.[key], errors);

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={(field) => (
                <FormControl fullWidth={fullWidth} error={!!fieldError?.message} sx={canadaGibsonFont}>
                    <InputLabel>{label}</InputLabel>
                    <Select
                        label={label}
                        MenuProps={{ disableScrollLock: true }}
                        {...field}
                        {...muiProps}
                        renderValue={(selected) => {
                            const entry = colourMap?.[selected];
                            if (typeof entry !== "string") return selected;

                            const [topRaw, bottomRaw] = entry.split(",").map((s) => s?.trim());
                            const top = topRaw || bottomRaw || "";
                            const bottom = bottomRaw || topRaw || "";

                            return (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Box
                                        component="span"
                                        sx={{
                                            display: "inline-block",
                                            width: 20,
                                            height: 20,
                                            borderRadius: "50%",
                                            background: `linear-gradient(to bottom, ${top} 55%, ${bottom} 45%)`,
                                            mr: 1,
                                        }}
                                    />
                                    <span>{selected}</span>
                                </Box>
                            );
                        }}
                    >
                        {renderOptions()}
                    </Select>
                    {fieldError && <FormHelperText>{fieldError?.message}</FormHelperText>}
                </FormControl>
            )}
        />
    );
}
